import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { ArrowUpDown, Euro, Layers3, Package, Image, Link } from "lucide-react";

import React from "react";

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor("productImgUrl", {
    // cell: (info) => info.getValue(),
    cell: (info) => (
      <span className="flex items-center justify-center">
        <img src={info.getValue()} alt="" width={35} height={35} className="" />
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <Image className="mr-2" size={16} />
      </span>
    ),
  }),
  columnHelper.accessor("product", {
    cell: (info) => {
      // @ts-ignore
      const value = info.getValue().name || "";
      // @ts-ignore
      const displayValue = value
        ? // @ts-ignore
          value?.substring(0, 35).toLocaleLowerCase()
        : "";
      const tooltipValue = value ? value : "";
      // @ts-ignore
      const showEllipsis = value.length > 35;
      return (
        <a
          href={`/product/${
            //@ts-ignore
            info.getValue().id
          }`}
          className="tooltip text-xs text-center cursor-pointer"
        >
          {displayValue} {showEllipsis ? "..." : ""}
          <span className="tooltiptext">{tooltipValue}</span>
        </a>
      );
    },
    header: () => (
      <span className="flex items-center justify-center">
        <Package className="mr-2" size={16} /> Produit
      </span>
    ),
  }),
  columnHelper.accessor("price", {
    id: "lastPrice",
    cell: (info) => (
      <span className="italic text-center ">
        {parseFloat(info.getValue()).toFixed(2) || info.getValue()} €
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <Euro className="mr-2" size={16} /> Prix
      </span>
    ),
  }),
  columnHelper.accessor("productQuantity", {
    id: "productQuantity",
    cell: (info) => (
      <span className="italic text-center">{info.getValue()} pcs</span>
    ),
    header: () => (
      <span className="flex items-center">
        <Layers3 className="mr-2" size={16} /> Stock
      </span>
    ),
  }),
  columnHelper.accessor("salesSum", {
    header: () => (
      <span className="flex items-center">
        <Layers3 className="mr-2" size={16} /> Ventes
      </span>
    ),
    cell: (info) => (
      <span className="italic text-center">{info.getValue()} pcs</span>
    ),
  }),
  columnHelper.accessor("ca", {
    header: () => (
      <span className="flex items-center">
        <Link className="mr-2" size={16} /> CA
      </span>
    ),
    cell: (info) => (
      <span className="flex items-center justify-center">
        {info.getValue()} €
      </span>
    ),
  }),
];

export const BestSellingProductsTable = ({ data }) => {
  // const [data] = React.useState(() => [...iData]);
  const [sorting, setSorting] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");
  const skipPageResetRef = React.useRef();

  const table = useReactTable({
    data,
    // @ts-ignore
    columns,
    state: {
      sorting,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    // @ts-ignore
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),

    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
    // re render the component when the data changes
    // forceUpdate((prev) => !prev),
    // autoResetPageIndex: !skipPageResetRef.current,
    // autoResetExpanded: !skipPageResetRef.current,
  });

  return (
    <div className="flex flex-col mx-auto py-2 sm:px-6 lg:px-2">
      <div className="overflow-x-auto bg-white rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="px-6 py-3 text-center text-xs font-medium text-gray-500 tracking-wider"
                  >
                    <div
                      {...{
                        className: header.column.getCanSort()
                          ? "cursor-pointer select-none flex items-center justify-center"
                          : "",
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      <ArrowUpDown className="ml-2" size={14} />
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-50">
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="px-2 py-1 whitespace-nowrap text-xs text-gray-500 text-center"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
